/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Addons_Toast_Schedule_CanceledInputs */



/**
* | output |
* | --- |
* | "Scheduled change canceled." |
*
* @param {Sub_Addons_Toast_Schedule_CanceledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_toast_schedule_canceled = /** @type {((inputs?: Sub_Addons_Toast_Schedule_CanceledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Toast_Schedule_CanceledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geplante Änderung abgebrochen.")
	return /** @type {LocalizedString} */ ("Scheduled change canceled.")
});